import { useId, useState } from 'react';
import PrimaryActionButton from './PrimaryActionButton';
import './SavingPicks.css';

function SpeakerPortrait({ speaker }) {
    const [failedURL, setFailedURL] = useState(null);
    const initials = speaker.name.trim().split(/\s+/).filter(Boolean).slice(0, 2).map(part => part[0]).join('');
    return <span className='savingPicksAvatar' aria-label={speaker.name || 'Selected speaker'} role='img'>
        {speaker.imageURL && speaker.imageURL !== failedURL
            ? <img src={speaker.imageURL} alt='' onError={() => setFailedURL(speaker.imageURL)} />
            : initials ? <span aria-hidden='true'>{initials}</span>
                : <svg aria-hidden='true' viewBox='0 0 24 24'><circle cx='12' cy='8' r='4' /><path d='M4 21v-2a8 8 0 0 1 16 0v2' /></svg>}
    </span>;
}

export default function SavingPicks({ speakers = [], error = null, delayed = false, timedOut = false, errorMessage = null, onRetry, onHome }) {
    const titleId = useId();
    const singular = speakers.length === 1;
    const recovery = Boolean(error) || timedOut;
    const pickLabel = singular ? 'pick' : 'picks';
    const savingTitle = speakers.length === 0 ? 'Finishing setup' : `Saving your ${pickLabel}`;
    const errorTitle = speakers.length === 0 ? 'Couldn’t finish setup' : `Couldn’t save your ${pickLabel}`;
    const title = timedOut ? 'Taking longer than expected' : error ? errorTitle : savingTitle;

    return <section className='savingPicks' aria-labelledby={titleId}>
        {speakers.length > 0 && <div className='savingPicksAvatars' role='group'
            aria-label={`${speakers.length} selected ${singular ? 'speaker' : 'speakers'}`}>
            {speakers.slice(0, 3).map(speaker => <SpeakerPortrait key={speaker.id} speaker={speaker} />)}
            {speakers.length > 3 && <span className='savingPicksAvatar savingPicksOverflow'
                role='img' aria-label={`${speakers.length - 3} more ${speakers.length === 4 ? 'speaker' : 'speakers'}`}>
                +{speakers.length - 3}
            </span>}
        </div>}
        <div className='savingPicksStatus' role={recovery ? 'alert' : 'status'} aria-atomic='true'>
            <h1 id={titleId} className='authFlowTitle savingPicksTitle'>{title}</h1>
            {!recovery && delayed && <p className='savingPicksMessage'>Taking longer than usual</p>}
            {recovery && errorMessage && <p className='savingPicksMessage'>{errorMessage}</p>}
            {!recovery && <span className='savingPicksSpinner' aria-hidden='true' />}
        </div>
        {recovery && <div className='savingPicksError'>
            <PrimaryActionButton type='button' onClick={onRetry}>Try again</PrimaryActionButton>
            <button className='savingPicksHome' type='button' onClick={onHome}>Go to Home</button>
        </div>}
    </section>;
}
